import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getUserQuestionByAnswererId } from "../../../api/userQuestion";

export const useUserQuestions = (answererId: string) => {
    const queryKey = useMemo(() => ["userQuestion", answererId], [answererId]);
    const { data: userQuestions, isLoading } = useQuery(
        queryKey,
        () => getUserQuestionByAnswererId(answererId),
        { refetchOnMount: "always" }
    );

    return {
        userQuestions,
        isLoading,
    };
};
